import Button from '@jetbrains/ring-ui/components/button/button'
import ButtonGroup from '@jetbrains/ring-ui/components/button-group/button-group'
import {memo, Suspense, useCallback} from 'react'
import {useLocation} from 'react-router-dom'

import {queryToObject} from '../../../utils/queryParams'
import {useChangeProblemsFilter} from '../../packages/Problems/Problems.hooks'
import AllUserSelect from '../UserSelect/AllUserSelect'
import type {UserSelectSelectedItem} from '../UserSelect/UserSelect.types'

import {
  getInvestigatedQueryParam,
  investigationFilterItems,
  InvestigationStatusFilter as InvestigationStatus,
} from './InvestigationStatusFilter.utils'

import styles from './InvestigationStatusFilter.css'

type Props = {
  onChange?: () => void
}
function InvestigationStatusFilter({onChange}: Props) {
  const location = useLocation()
  const investigated = getInvestigatedQueryParam(location)

  const selectedUser = queryToObject(location.search).assignee
  const onFilterChange = useChangeProblemsFilter()

  const onInvestigationStatusChange = useCallback(
    (key: string) => {
      const value =
        key === InvestigationStatus.ALL ? null : String(key === InvestigationStatus.INVESTIGATED)
      const username = key !== InvestigationStatus.INVESTIGATED ? {assignee: null} : {}
      onFilterChange({investigated: value, ...username})
      onChange?.()
    },
    [onChange, onFilterChange],
  )

  const onUsernameChange = useCallback(
    (item: UserSelectSelectedItem) => {
      onFilterChange({assignee: item?.value ?? ''})
      onChange?.()
    },
    [onChange, onFilterChange],
  )

  return (
    <div className={styles.container}>
      <ButtonGroup>
        {investigationFilterItems.map(({key, label}) => (
          <Button
            key={key}
            active={investigated === key}
            onClick={() => onInvestigationStatusChange(key)}
          >
            {label}
          </Button>
        ))}
      </ButtonGroup>
      {investigated === InvestigationStatus.INVESTIGATED && (
        <Suspense>
          <AllUserSelect
            label={'Assigned to'}
            selected={selectedUser}
            onChange={onUsernameChange}
          />
        </Suspense>
      )}
    </div>
  )
}
export default memo(InvestigationStatusFilter)
